<template>
    <div class="all clearfix">
        <Myleft ref="left"></Myleft>
        <div class="mdCont fl bgff w730 ml10">
            <div><img :src="'static/images/'+tags+'.jpg'"/></div>
            <div class="grid pb30 pt0">
                <div class="warp clearfix">
                    <div class="warp-body mh270">
                        <div class="no-data" v-if="nodata.hotList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                        <ul class="article-list">
                            <li class="imgText clearfix" v-for="(item,index) in hotList" :key="index">
                                <router-link class="img fl cp" :to="{path:'pointDetail',query:{id:item.id}}" target="_blank"><img :src="item.picurl" :onerror="defaultImg"/></router-link>
                                <div class="hidden">
                                    <div class="clearfix mt15">
                                        <h2 class="fl ovhidden2"><router-link class="cr00 cp" :to="{path:'pointDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link></h2>
                                    </div>
                                    <p class="ziduan mt10 cr77">
                                        <span v-if="item.author_name!=''">{{item.author_name}} ·  </span>
                                        <span v-if="item.publish_time!=null">{{timeFilter(item.publish_time)}}</span>
                                    </p>
                                </div>
                            </li>
                            
                        </ul>
                        <div class="mt20 ac" v-if="isShowMore">
                            <a class="btnMmore color-8a8a99" href="javascript:void(0);" @click="showMore">加载更多</a>
                        </div>
                        <div class="mt20 ac" v-if="isShowEnd">
                            <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mrCont w330 bgff fr">
            <div class="grid">
                <div class="grid-header clearfix">
                    <h2 class="title"><img src="static/images/jzTit.png"/></h2>
                </div>
                <div class="grid-body mt15">
                    <ul class="jzNews">
                        <li class="mb20" v-for="(item,index) in jzNewsList" :key="index">
                            <div class="imgText clearfix">
                                <router-link class="img fl cp" :to="{path:'pointDetail',query:{id:item.id}}" target="_blank"><img :src="item.picurl" :onerror="defaultImg"/></router-link> 
                                <div class="hidden">
                                    <h4 class="ovhidden3 mt5 fs14">
                                        <router-link class="cr00 cp" :to="{path:'pointDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link>
                                    </h4>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="no-data pt30" v-if="nodata.jzNewsList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Myleft from '../../components/left'
import city from '../../components/city.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    components: {Myleft,VueDatepickerLocal,city},
    data() {
        return {
            jzNewsList:[],
            defaultImg:'this.src="static/images/default.png"',
            tags:'',
            hotList:[],
            pageCur:1,
            pageNum:6,
            dataCount:0,
            timeRange: [],
            startTime:null,
            endTime:null,
            province:'',//省份
            isShowMore:false,
            isShowEnd:false,
            nodata:{
                jzNewsList:false,
                hotList:false
            }
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.tags = that.$route.query.type;
            that.dataAjax();
            that.hotListAjax();
            that.$utils.screenHeight();
        }) 
    },
    watch: {
		$route(){
            let that = this;
            that.tags = that.$route.query.type;
            that.$refs.left.curType = that.tags;
            that.clearListData();
		},
	},
    methods: {
        // 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,7);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2])
            min = new Date(o[0], o[1]-1, o[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min,1);
            this.endDate = this.$utils.dateConversion(max,1);
        },
        dataAjax(){
            let that = this;
            let datas={
                column:'较真'
            };
            that.$api.get('viewpoint/index/list',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.jzNewsList = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata.jzNewsList = true;
                    }else{
                        that.nodata.jzNewsList = false;
                    }
                });
            });
        },
        // 地区筛选
        citySelect (name) {
            let province = name[1];
            let that = this;
            if(province === '全国'){
                that.province = '';
            }else{
                that.province = province;
            }
            that.clearListData();
        },
        hotListAjax(){
            let that = this;
            let datas={
                column:that.tags,
                start_time:that.startTime,
                end_time:that.endTime,
                province:that.province,
                perpage:that.pageNum,
                page:that.pageCur
            };
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('viewpoint/index/list',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    if(r.data.list.length<=0){
                        that.nodata.hotList = true;
                        return
                    }else{
                        that.nodata.hotList = false;
                    }
                    that.dataCount = r.data.count;
                    if(that.dataCount>that.pageNum*that.pageCur){
                        that.isShowMore = true;
                    }else{
                        that.isShowMore = false;
                        that.isShowEnd = true;
                    }
                    that.hotList = that.hotList.concat(r.data.list);
                });
            });
        },
        showMore(){
            let that = this;
            that.pageCur++;
            that.hotListAjax();
        },
        clearListData(){
            let that = this;
            that.isShowMore = false;
            that.isShowEnd = false;
            that.pageCur = 1;
            that.hotList = [];
            that.hotListAjax()
        },
        choseType(type){
            let that = this;
            that.typeName = type;
            that.clearListData();
        },
       
        disabledDate (time) {
            //return time < this.min || time > this.max
        },
        selectedDate (date) {
            let that = this;
            if(date == undefined){
                that.startTime = '';
                that.endTime = '';  
            }else{
                that.startTime = that.$utils.dateConversion(that.timeRange[0],1);
                that.endTime = that.$utils.dateConversion(that.timeRange[1],1);
            }
            that.clearListData();
        },
        timeFilter(t){
            var newT = '';
            let tmp = t.split('-');
            newT = tmp[0]+'年'+tmp[1]+'月'+tmp[2]+'日';
            return newT;
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/point/viewpoint.vue